import { render, staticRenderFns } from "./LocationRemarksSelection.vue?vue&type=template&id=02c95258"
import script from "./LocationRemarksSelection.vue?vue&type=script&lang=js"
export * from "./LocationRemarksSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports